<div class="automatic-debit-table-component" *ngIf="contractListPaginated.length > 0">
    <table class="table table-striped table-hover">
        <thead>
            <tr>
                <th scope="col">Contrato</th>
                <th scope="col">Entidade</th>
                <th scope="col">Nº Fatura</th>
                <th scope="col">Vencimento</th>
                <th scope="col">Valor</th>
                <th scope="col">Data autorizada</th>
                <th scope="col">Observação</th>
            </tr>
        </thead>
        <tbody>
            <tr (click)="viewContract(contract)" class="pointer" *ngFor="let contract of contractListPaginated">
                <td>{{ contract.contractFullName }}</td>
                <td>{{ contract.entityDescription }}</td>
                <td>{{ contract.billetNumber }}</td>
                <td>{{ contract.dueDateBillet | date: 'dd/MM/yyyy' }}</td>
                <td>
                    <strong>{{ contract.billetValue - contract.discountValue | currency }} </strong>
                </td>
                <td>{{ contract.authorizationDate | date: 'dd/MM/yyyy' }}</td>
                <td>{{ contract.observation }}</td>
            </tr>
        </tbody>
    </table>

    <div class="d-flex justify-content-between p-2">
        <label>Total: {{ collectionSize }}</label>
        <ngb-pagination
            [collectionSize]="collectionSize"
            [(page)]="page"
            [pageSize]="pageSize"
            (pageChange)="loadPaginator()">
        </ngb-pagination>

        <select class="custom-select" style="width: auto" [(ngModel)]="pageSize" (ngModelChange)="loadPaginator()">
            <option [ngValue]="50">50 por pág.</option>
            <option [ngValue]="100">100 por pág.</option>
            <option [ngValue]="200">200 por pág.</option>
        </select>
    </div>
</div>
